import styled from 'styled-components';
import { MobileSliderPagesContentStyled } from '../../../components/styled/MobileSliderPagesStyled';

export const MobileSliderPagesContentCommunityStyled = styled(MobileSliderPagesContentStyled)`
    flex-flow: row wrap; 
    flex-grow: initial; 
    gap: 8px;
`;

export const MobileSliderPagesContentCommunityItemStyled = styled.div`
    position: relative;
    width: calc(50% - 4px);
    height: 104px;
    @media (max-width: 375px) {
       width: 100%;
    }
`;
